import { Component, OnInit, Inject } from '@angular/core';
import { MainService } from 'src/app/services/main.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MangeUnitsComponent } from '../mange-units/mange-units.component';
import { UnitsService } from 'src/app/services/units.service';

@Component({
  selector: 'app-unit-block',
  templateUrl: './unit-block.component.html',
  styleUrls: ['./unit-block.component.css']
})
export class UnitBlockComponent implements OnInit {

  allGate_array:any
  allWHitGates:any
  gateChoise:any = []
  gateWhitChoices:any = []
  erorrGate = false
  erorrGatewhite = false
  blackList_arr:any = [] 
  WhiteList_arr:any = [] 

  constructor(private rest : MainService , 
    private unitservice : UnitsService,
     public dialogRef: MatDialogRef<MangeUnitsComponent> , 
     @Inject(MAT_DIALOG_DATA) public data: any ){}

  ngOnInit(){
    console.log(this.data)
    this.getData()
    if(this.data.name == 'client'){
      this.retriveClientBlackList()
    }
  }

  getData(){
    this.rest.allGats().subscribe((res:any) => {
      console.log(res)
      this.allGate_array = res
      this.allWHitGates = res
    })
  }

  chooseGate(value:any){
    this.erorrGate = false
    if(this.gateChoise.includes(value)){
      return
    }else {
      this.gateChoise.push(value)
    }
  }


  chooseGateWhite(value:any){
    this.erorrGatewhite = false
    if(this.gateWhitChoices.includes(value)){
      return
    }else {
      this.gateWhitChoices.push(value)
    }
  }

  removeGate(id:any,value:any){

    console.log(id,value)
    this.gateChoise.splice(value, 1);

    if(this.data.name == 'client'){
      let clients = [this.data.id]
      let gates = [id]
      let data = {
        gates : gates,
        clients : clients
      }
      this.unitservice.removeBlackListGateClient(data).subscribe((res:any) => {
        console.log(res)
      })
    }
  }
  removeGatewhite(id:any ,value:any){
    this.gateWhitChoices.splice(value, 1);

    if(this.data.name == 'client'){
      let clients = [this.data.id]
      let gates = [id]
      let data = {
        gates : gates,
        clients : clients
      }
      this.unitservice.removeWhiteListGateClient(data).subscribe((res:any) => {
        console.log(res)
      })
    }
  }
  


  saveChange(){
    if(this.gateChoise.length != 0){
      this.erorrGate = false
      let gateId :any = []
      this.gateChoise.forEach((element:any) => {
        this.blackList_arr.push(element.id)
      });
      let data = {
        name : 'black',
        balckList : this.blackList_arr,
        WhiteList : this.WhiteList_arr
      }
      this.dialogRef.close(data);
    }else {
      this.erorrGate = true
    }
  }
  savewhiteChange(){
    if(this.gateWhitChoices.length != 0){
      this.erorrGatewhite = false
      let gateId :any = []
      this.gateWhitChoices.forEach((element:any) => {
        this.WhiteList_arr.push(element.id)
      });
      let data = {
        name : 'white',
        balckList : this.blackList_arr,
        WhiteList : this.WhiteList_arr
      }
      this.dialogRef.close(data);
    }else {
      this.erorrGatewhite = true
    }
  }

  retriveUnitBlackList(){
    this.unitservice.retiveUnitBlackList(this.data.id).subscribe((res:any) => {
      console.log(res)
    })
  }

  retriveClientBlackList(){
    this.unitservice.retiveClientBlackList(this.data.id).subscribe((res:any) => {
      console.log(res)
      this.gateChoise = res.blacklisted_gates
      this.gateWhitChoices = res.whitelisted_gates
    })
  }

}
